<template>
  <div style="width: 300px;">
    <sFormItem
      prop="ForceBpmKey"
      :rules="rules.ForceBpmKey">
      <sInput
        clearable
        :max-length="1500"
        :placeholder="$t('ChartCode')"
        trim
        :value="valueMutable.ForceBpmKey"
        @update:value="val => setParameters('ForceBpmKey', val)"/>
    </sFormItem>
    <sFormItem
      prop="Comment"
      :rules="rules.Comment">
      <sInput
        clearable
        :max-length="1500"
        :placeholder="$t('Common.OptionalComment')"
        trim
        :value="valueMutable.Comment"
        @update:value="val => setParameters('Comment', val)"/>
    </sFormItem>
  </div>
</template>
<script>

export default {
  name: 'startForceBpmByKey',
  data() {
    const that = this
    return {
      rules: {
        ForceBpmKey: {
          required: true,
          trigger: 'change',
          message: that.$t('Validate.Required'),
          validator(rule, value, callback) {
            if (!that.valueMutable.ForceBpmKey) {
              callback(new Error(that.$t('Validate.Required')))
            }
            callback()
          }
        }
      },
    }
  },
  methods: {
    setParameters(field, props) {
      const result = this.$_.cloneDeep(this.value)
      const parameters = this.$_.cloneDeep(this.valueMutable)

      parameters[field] = props
      result.parameters = JSON.stringify(parameters)

      this.$emit('update:value', result)
    },
  },
  computed: {
    valueMutable: {
      get() {
        const defaultModel = {
          ForceBpmKey: null,
          Comment: null,
        }
        let result = {}
        if (!this.value?.parameters) {
          result = defaultModel
        } else {
          try {
            result = JSON.parse(this.value.parameters) || defaultModel
          } catch {
            this.$notice.error({
              title: this.$t('Common.ErrorTitle'),
              message: this.$t('Automation.ErrorActionParams'),
              showClose: true,
              progress: true,
            })
            result = defaultModel
          }
        }
        if (!Object.keys(result)?.length) {
          result = defaultModel
        }
        return result
      }
    },
  },
  props: {
    value: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    additionalProps: {
      type: [Object, Array]
    },
  },
  i18n: {
    messages: {
      uk: {
        ChartCode: 'Код діаграми',
      },
      en: {
        ChartCode: 'Chart code',
      },
    }
  }
}
</script>
